import { APIClient } from "../../base";
import { PaginationInterface } from "../../../../interfaces/PaginationInterface";

const LogV2Api = {
    getAll: async (pagination: PaginationInterface) => await APIClient.get('/v2/logs', pagination),
    getDetail: async (id: number | string) => await APIClient.get('/v2/logs/' + encodeURIComponent(String(id)), {}),
};

export default LogV2Api;
